var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.058 0.431641C22.0394 0.431641 0.0578613 22.4133 0.0578613 49.4318C0.0578613 76.45 22.0394 98.4316 49.058 98.4316C76.0765 98.4316 98.0579 76.45 98.0579 49.4318C98.0579 22.4133 76.0763 0.431641 49.058 0.431641ZM49.058 90.4486C26.4427 90.4486 8.04176 72.0465 8.04176 49.4318C8.04176 26.8166 26.4427 8.41534 49.058 8.41534C71.673 8.41534 90.0742 26.8166 90.0742 49.4318C90.0742 72.0467 71.673 90.4486 49.058 90.4486ZM74.368 36.8284C75.1868 38.0148 74.8897 39.64 73.7032 40.4594L50.0511 56.8006C49.6072 57.1062 49.0878 57.2617 48.567 57.2617C48.1522 57.2617 47.7356 57.1623 47.3543 56.9636C46.4963 56.5102 45.9569 55.6216 45.9569 54.6518V19.6783C45.9569 18.2376 47.1263 17.0682 48.567 17.0682C50.0082 17.0682 51.1769 18.2376 51.1769 19.6783V49.6763L70.7358 36.1632C71.9241 35.3476 73.5523 35.6453 74.368 36.8284Z",
    fill: "#004B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.6d0c2f7916d2a0b03b15f42b58747d91.svg";
export { ForwardRef as ReactComponent };